import Vue from "vue";

Vue.directive("second-navbar-toogle", {
    bind(el, binding)
    {
        el.onclick = function(event)
        {
            $(el).toggleClass('nav-more--active');
            $('.mainmenu--first').toggleClass('nav-more-open');

            $(".js--mainmenu").slideToggle({
                start: function () {
                    $(this).css({
                        display: "flex"
                    })
                }
            });
        };
    }
});
